import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SKEY = "nosh_session";

export function getSessionId() {
  let id = localStorage.getItem(SKEY);
  if (!id) {
    id = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(SKEY, id);
  }
  return id;
}

export function trackVisit(path) {
  try {
    axios.post(`${API}/track/visit`, { path, session_id: getSessionId() }).catch(() => {});
  } catch (e) { /* no-op */ }
}

export function trackCart(payload) {
  try {
    axios.post(`${API}/track/cart`, { session_id: getSessionId(), ...payload }).catch(() => {});
  } catch (e) { /* no-op */ }
}
